import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { getBuilderSchema } from '../api/botsApi';

const StrategySchemaContext = createContext(null);

export const useStrategySchema = () => useContext(StrategySchemaContext);

export const StrategySchemaProvider = ({ children }) => {
  const [schema, setSchema] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        if (mounted) setIsLoading(false);
        return;
      }

      try {
        const s = await getBuilderSchema({});
        if (mounted) setSchema(s);
      } catch (e) {
        if (mounted) setError(e);
      } finally {
        if (mounted) setIsLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const capabilities = useMemo(() => schema?.['x-capabilities'] || {}, [schema]);
  const riskSchema = schema?.properties?.risk; // convenience pointer

  const value = useMemo(() => ({ schema, riskSchema, capabilities, isLoading, error }), [schema, riskSchema, capabilities, isLoading, error]);

  return (
    <StrategySchemaContext.Provider value={value}>
      {children}
    </StrategySchemaContext.Provider>
  );
};
